// src/data/about.js
const AboutItems = [
  'Our Mission Values',
  'Events Hub',
  'FAQs',
];

export default AboutItems;
